import { Commit } from 'vuex';

const DEFAULT_TIMEOUT = 10000;

interface GlobalSnackbarState {
  message: string
  show: boolean,
  timeout: number,
  color: string,
  top: boolean,
}

export default {

  namespaced: false,

  state: (): GlobalSnackbarState => ({
    message: '',
    show: false,
    timeout: DEFAULT_TIMEOUT,
    color: 'white',
    top: true,
  }),

  mutations: {
    DISPLAY_GLOBAL_SNACKBAR: (state: GlobalSnackbarState, config: GlobalSnackbarState) => {
      state.message = (!!config?.message || '') as string;
      state.show = !!config?.show || true;
      state.timeout = (!!config?.timeout || 0) as number;
      state.color = (!!config?.color || 'info') as string;
      state.top = !!config?.top || true;
    },
    DISPLAY_GLOBAL_SNACKBAR_ERROR: (state: GlobalSnackbarState, message: string) => {
      state.message = message || 'Spiacenti, si è verificato un errore!';
      state.color = 'error';
      state.timeout = DEFAULT_TIMEOUT;
      state.top = true;
      state.show = true;
    },
    DISPLAY_GLOBAL_SNACKBAR_SUCCESS: (state: GlobalSnackbarState, message: string) => {
      state.message = message || 'Operazione effettuata con successo!';
      state.color = 'success';
      state.timeout = DEFAULT_TIMEOUT;
      state.top = true;
      state.show = true;
    },
    DISPLAY_GLOBAL_SNACKBAR_WARNING: (state: GlobalSnackbarState, message: string) => {
      state.message = message || 'Attenzione!';
      state.color = 'warning';
      state.timeout = DEFAULT_TIMEOUT;
      state.top = true;
      state.show = true;
    },
    DISPLAY_GLOBAL_SNACKBAR_INFO: (state: GlobalSnackbarState, message: string) => {
      state.message = message || 'Attenzione!';
      state.color = 'info';
      state.timeout = DEFAULT_TIMEOUT;
      state.top = true;
      state.show = true;
    },
    CLOSE_GLOBAL_SNACKBAR: (state: GlobalSnackbarState) => {
      state.show = false;
    },
    OPEN_GLOBAL_SNACKBAR: (state: GlobalSnackbarState) => {
      state.show = true;
    },
  },

  actions: {
    show_global_error_message({ commit }: {commit: Commit}, message: string) {
      commit('DISPLAY_GLOBAL_SNACKBAR_ERROR', message);
    },
    show_global_success_message({ commit }: {commit: Commit}, message: string) {
      commit('DISPLAY_GLOBAL_SNACKBAR_SUCCESS', message);
    },
    show_global_info_message({ commit }: {commit: Commit}, message: string) {
      commit('DISPLAY_GLOBAL_SNACKBAR_INFO', message);
    },
    show_global_warning_message({ commit }: {commit: Commit}, message: string) {
      commit('DISPLAY_GLOBAL_SNACKBAR_WARNING', message);
    },
    show_global_snackbar({ commit }: {commit: Commit}, config: GlobalSnackbarState) {
      commit('DISPLAY_GLOBAL_SNACKBAR', config);
    },
    close_global_snackbar({ commit }: {commit: Commit}) {
      commit('CLOSE_GLOBAL_SNACKBAR');
    },
    open_global_snackbar({ commit }: {commit: Commit}) {
      commit('OPEN_GLOBAL_SNACKBAR');
    },
  },

  getters: {
    global_snackbar_message: (state: GlobalSnackbarState) => state.message,
    global_snackbar_show: (state: GlobalSnackbarState) => state.show,
    global_snackbar_color: (state: GlobalSnackbarState) => state.color,
    global_snackbar_timeout: (state: GlobalSnackbarState) => state.timeout,
    global_snackbar_top: (state: GlobalSnackbarState) => state.top,
  },

};
